/* Giolor — Quiz "¿Cuál es tu aroma?"
   Subir a: Shopify admin → Editar código → Assets → Agregar un nuevo recurso → nombre exacto: section-quiz-descubre.js
*/
(function () {
  "use strict";

  // Mapeo de respuestas -> perfiles (a,b,c,d,e). Cada opción marcada suma 1 punto a cada perfil listado.
  var MAP = {
    p2: { a: ["a"], b: ["b"], c: ["c"], d: ["d"], e: ["e"], f: ["f"] },
    p3: {
  dia_dia: ["b"],
  trabajo: ["c"],
  salidas: ["d"],
  relax: ["e"],
  celebracion: ["a"],
  verano: ["f"]
},
p4: {
  citricos: ["b"],
  florales_suaves: ["a"],
  amaderados: ["c"],
  especiados: ["d"],
  dulces_golosos: ["e"],
  citricos_salinos: ["f"]
},
p5: {
  ligero: ["b"],
  luminoso: ["a"],
  elegante: ["c"],
  caracter: ["d"],
  abrazo: ["e"],
  calido_salino: ["f"]
}
}
  var GENDER_TAGS = {
    hombre: ["Hombre", "Unisex"],
    mujer: ["Mujer", "Unisex"],
    unisex: null // null = sin filtro, incluye todo
  };

  function formatCLP(price) {
    var n = Math.round(parseFloat(price || 0));
    return "$" + n.toLocaleString("es-CL");
  }

  function initQuiz(root) {
    var form = root.querySelector("[data-gquiz-form]");
    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-gquiz-step]"));
    var totalSteps = steps.length;
    var prevBtn = root.querySelector("[data-gquiz-prev]");
    var nextBtn = root.querySelector("[data-gquiz-next]");
    var submitBtn = root.querySelector("[data-gquiz-submit]");
    var errorEl = root.querySelector("[data-gquiz-error]");
    var progressBar = root.querySelector("[data-gquiz-progress]");
    var stepNumEl = root.querySelector("[data-gquiz-stepnum]");
    var resultsEl = root.querySelector("[data-gquiz-results]");
    var heroEl = root.querySelector("[data-gquiz-hero]");
    var altWrap = root.querySelector("[data-gquiz-altwrap]");
    var altGrid = root.querySelector("[data-gquiz-altgrid]");
    var resultTitleEl = root.querySelector("[data-gquiz-result-title]");
    var retryBtn = root.querySelector("[data-gquiz-retry]");
    var toastEl = root.querySelector("[data-gquiz-toast]");
    var dataScript = root.querySelector("[data-gquiz-products]");

    var products = [];
    try {
      products = JSON.parse(dataScript.textContent || "[]");
    } catch (e) {
      products = [];
    }

    var current = 1;

    function updateProgress() {
      var pct = (current / totalSteps) * 100;
      progressBar.style.width = pct + "%";
      stepNumEl.textContent = current;
    }

    function showStep(n) {
      steps.forEach(function (el) {
        el.hidden = parseInt(el.getAttribute("data-gquiz-step"), 10) !== n;
      });
      prevBtn.hidden = n === 1;
      nextBtn.hidden = n === totalSteps;
      submitBtn.hidden = n !== totalSteps;
      errorEl.hidden = true;
      updateProgress();
    }

    function stepIsValid(n) {
      var el = steps[n - 1];
      var inputs = el.querySelectorAll("input");
      return Array.prototype.some.call(inputs, function (i) {
        return i.checked;
      });
    }

    nextBtn.addEventListener("click", function () {
      if (!stepIsValid(current)) {
        errorEl.hidden = false;
        return;
      }
      if (current < totalSteps) {
        current++;
        showStep(current);
      }
    });

    prevBtn.addEventListener("click", function () {
      if (current > 1) {
        current--;
        showStep(current);
      }
    });

    function getAnswers() {
      var data = new FormData(form);
      var answers = { p1: null, p2: [], p3: [], p4: [], p5: [] };
      answers.p1 = data.get("p1");
      ["p2", "p3", "p4", "p5"].forEach(function (key) {
        answers[key] = data.getAll(key);
      });
      return answers;
    }

    function computeProfiles(answers) {
      var score = { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0  };
      ["p2", "p3", "p4", "p5"].forEach(function (q) {
        answers[q].forEach(function (val) {
          var letters = MAP[q][val] || [];
          letters.forEach(function (l) {
            score[l] += 1;
          });
        });
      });
      var max = Math.max(score.a, score.b, score.c, score.d, score.e, score.f);
      var winners = Object.keys(score).filter(function (l) {
        return score[l] === max && max > 0;
      });
      return winners.length ? winners : ["a", "b", "c", "d", "e", "f"]; // fallback improbable
    }

    function productMatchesGender(product, genderAnswer) {
      var allowed = GENDER_TAGS[genderAnswer];
      if (!allowed) return true;
      return product.tags.some(function (t) {
        return allowed.indexOf(t) !== -1;
      });
    }

    function productProfileTags(product) {
      return product.tags
        .filter(function (t) {
          return /^quiz-[a-f]$/i.test(t);
        })
        .map(function (t) {
          return t.toLowerCase().replace("quiz-", "");
        });
    }

    function pickResults(winners, genderAnswer) {
      var pool = products.filter(function (p) {
        if (!productMatchesGender(p, genderAnswer)) return false;
        var tags = productProfileTags(p);
        return tags.some(function (t) {
          return winners.indexOf(t) !== -1;
        });
      });

      pool.forEach(function (p) {
        var tags = productProfileTags(p);
        p._matchCount = tags.filter(function (t) {
          return winners.indexOf(t) !== -1;
        }).length;
      });

      pool.sort(function (x, y) {
        if (x.available !== y.available) return x.available ? -1 : 1;
        if (y._matchCount !== x._matchCount) return y._matchCount - x._matchCount;
        return 0;
      });

      return pool;
    }

    function variantOptionsHTML(variants) {
  return variants
    .filter(function (v) { return v.available; })
    .map(function (v) {
      return '<option value="' + v.id + '">' + v.title + ' — ' + formatCLP(v.price) + '</option>';
    })
    .join("");
}

function cardHTML(product, isHero) {
  var img = product.image || "";
  var cls = isHero ? "gquiz__card gquiz__card--hero" : "gquiz__card";
  var variants = (product.variants || []).filter(function (v) { return v.available; });
  var hasMultipleVariants = variants.length > 1;

  var actionsHTML;
  if (!product.available) {
    actionsHTML = '<p class="gquiz__agotado">Agotado por ahora — <a href="' + product.url + '">ver producto</a></p>';
  } else if (hasMultipleVariants) {
    actionsHTML =
      '<div class="gquiz__cardactions" data-cardactions>' +
      '<button type="button" class="gquiz__btn gquiz__btn--primary gquiz__addcart">Agregar al carrito</button>' +
      '<a href="' + product.url + '" class="gquiz__btn gquiz__btn--ghost">Ver producto</a>' +
      "</div>" +
      '<div class="gquiz__variantpicker" data-variantpicker hidden>' +
      '<select class="gquiz__variantselect">' + variantOptionsHTML(variants) + "</select>" +
      '<div class="gquiz__variantpickeractions">' +
      '<button type="button" class="gquiz__btn gquiz__btn--primary gquiz__confirmadd">Agregar</button>' +
      '<button type="button" class="gquiz__btn gquiz__btn--ghost gquiz__cancelpicker">Cancelar</button>' +
      "</div>" +
      "</div>";
  } else {
    actionsHTML =
      '<div class="gquiz__cardactions">' +
      '<button type="button" class="gquiz__btn gquiz__btn--primary gquiz__addcart" data-variant-id="' + product.variantId + '">Agregar al carrito</button>' +
      '<a href="' + product.url + '" class="gquiz__btn gquiz__btn--ghost">Ver producto</a>' +
      "</div>";
  }

  return (
    '<div class="' + cls + '" data-variant-id="' + product.variantId + '">' +
    (img ? '<a href="' + product.url + '" class="gquiz__cardimg"><img src="' + img + '" alt="' + product.title + '" loading="lazy"></a>' : "") +
    '<div class="gquiz__cardbody">' +
    '<p class="gquiz__cardvendor">' + product.vendor + "</p>" +
    '<a href="' + product.url + '" class="gquiz__cardtitle">' + product.title + "</a>" +
    '<p class="gquiz__cardlabel">Descúbrelo desde</p>' +
    '<p class="gquiz__cardprice">' + formatCLP(product.price) + "</p>" +
    actionsHTML +
    "</div>" +
    "</div>"
  );
}

    function renderResults(list) {
      if (!list.length) {
        resultTitleEl.textContent = "Aún no tenemos tu match perfecto listo";
        heroEl.innerHTML = '<p class="gquiz__empty">Prueba de nuevo o mira todo nuestro catálogo en <a href="/collections/all">Descubre</a>.</p>';
        altWrap.hidden = true;
        return;
      }
      var hero = list[0];
      var alts = list.slice(1, 4);

      resultTitleEl.textContent = "Tu perfume ideal es " + hero.title;
      heroEl.innerHTML = cardHTML(hero, true);

      if (alts.length) {
        altGrid.innerHTML = alts.map(function (p) {
          return cardHTML(p, false);
        }).join("");
        altWrap.hidden = false;
      } else {
        altWrap.hidden = true;
      }
    }

    function showToast(msg) {
      toastEl.textContent = msg;
      toastEl.hidden = false;
      toastEl.classList.add("is-visible");
      clearTimeout(root._toastTimer);
      root._toastTimer = setTimeout(function () {
        toastEl.classList.remove("is-visible");
        toastEl.hidden = true;
      }, 2600);
    }
function addToCart(variantId, btn) {
  var original = btn.textContent;
  btn.disabled = true;
  btn.textContent = "Agregando…";
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
    .then(function (res) {
      if (!res.ok) throw new Error("cart_add_failed");
      return res.json();
    })
    .then(function () {
      window.location.href = "/cart";
    })
    .catch(function () {
      showToast("No pudimos agregarlo, intenta desde la ficha del producto");
      btn.disabled = false;
      btn.textContent = original;
    });
}

    root.addEventListener("click", function (e) {
  var addBtn = e.target.closest(".gquiz__addcart");
  if (addBtn) {
    var card = addBtn.closest(".gquiz__card");
    var picker = card.querySelector("[data-variantpicker]");
    if (picker) {
      card.querySelector("[data-cardactions]").hidden = true;
      picker.hidden = false;
    } else {
      addToCart(addBtn.getAttribute("data-variant-id"), addBtn);
    }
    return;
  }

  var cancelBtn = e.target.closest(".gquiz__cancelpicker");
  if (cancelBtn) {
    var card2 = cancelBtn.closest(".gquiz__card");
    card2.querySelector("[data-cardactions]").hidden = false;
    card2.querySelector("[data-variantpicker]").hidden = true;
    return;
  }

  var confirmBtn = e.target.closest(".gquiz__confirmadd");
  if (confirmBtn) {
    var card3 = confirmBtn.closest(".gquiz__card");
    var select = card3.querySelector(".gquiz__variantselect");
    if (select && select.value) {
      addToCart(select.value, confirmBtn);
    }
    return;
  }
});

    submitBtn.addEventListener("click", function () {
      if (!stepIsValid(current)) {
        errorEl.hidden = false;
        return;
      }
      var answers = getAnswers();
      var winners = computeProfiles(answers);
      var results = pickResults(winners, answers.p1);
      renderResults(results);

      form.hidden = true;
      root.querySelector("[data-gquiz-progresswrap]").hidden = true;
      resultsEl.hidden = false;
    });

    retryBtn.addEventListener("click", function () {
      form.reset();
      current = 1;
      showStep(1);
      form.hidden = false;
      root.querySelector("[data-gquiz-progresswrap]").hidden = false;
      resultsEl.hidden = true;
    });

    showStep(1);
  }

  function init() {
    document.querySelectorAll("[data-gquiz]").forEach(initQuiz);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();